import React from "react";

import { DateTime } from 'luxon';
import * as UI from "./ui";

const EntryItem = ({ item }) => {
  const displayTicketRanges = (item.ticketRanges)
    .map(({ min, max }) => `#${min}-${max}`)
    .join(", ");
  const displayAmount = item.status === "FREE" ? "No Donation" : item.formattedAmount;

  return (
    <UI.ItemLayout>
      <UI.EntrantLayout>
        <UI.Name>{item.firstName} {item.lastName}</UI.Name>
        <UI.TicketRange status={item.status}>Entries {displayTicketRanges}</UI.TicketRange>
      </UI.EntrantLayout>
      <UI.EntryDataLayout>
        <UI.Amount status={item.status}>{displayAmount}</UI.Amount>
        <UI.Date>{DateTime.fromISO(item.createdAt).toLocaleString(DateTime.DATE_SHORT)}</UI.Date>
      </UI.EntryDataLayout>
    </UI.ItemLayout>
  );
};

export default EntryItem;
